import { CompanyInfo } from 'api/company'

export const isRSWWorkerAvailabilityEnabled = (
  company?: CompanyInfo | null
) => {
  return Boolean(company)
}
